/* LogHomeMart page telemetry.
   Source of truth: tools/telemetry/lhm_track.js in the consulting repo.
   Loaded by snippets/lhm-telemetry.liquid, only on the pages we built.

   Transport is the store's own gtag from layout/theme.liquid (G-Z35ZWRQB4Q),
   the same mechanism as sections/lhm-intent-tiles.liquid on the homepage.
   Parameter names must match the custom dimensions registered in GA4.

   PII rule, enforced structurally rather than by care: field values are read by
   ALLOW-LIST. Numbers, ranges, checkboxes, radios and menus are read. Text,
   email, tel, password and search inputs are never read, so an email address
   cannot reach GA4 by accident no matter what is added to a page later. A text
   field can opt in explicitly with data-lhm-value. */
(function () {
  "use strict";
  if (window.__lhmTrack) return;

  var CFG = window.LHM_TRACK || {};
  var PAGE_KEY = CFG.key || "unknown";
  var PAGE_TYPE = CFG.type || "page";
  var DEBUG = /(?:^|[?&])lhm_debug=1(?:&|$)/.test(location.search);

  function send(name, params) {
    var p = { lhm_page_key: PAGE_KEY, lhm_page_type: PAGE_TYPE };
    if (params) for (var k in params) if (params[k] !== undefined && params[k] !== "") p[k] = params[k];
    if (DEBUG) { p.debug_mode = true; try { console.log("[lhm]", name, p); } catch (e) {} }
    if (typeof window.gtag === "function") window.gtag("event", name, p);
    else if (window.dataLayer) window.dataLayer.push(assign({ event: name }, p));
  }
  function assign(a, b) { for (var k in b) a[k] = b[k]; return a; }

  /* The calculator pages already define window.lhmTrack and already reach GA4
     with it (lhm_calc_complete is arriving). So DECORATE it, never replace it:
     existing calls keep working and gain page identity. */
  if (typeof window.lhmTrack === "function") {
    var prevTrack = window.lhmTrack;
    window.lhmTrack = function (n, p) {
      prevTrack(n, assign({ lhm_page_key: PAGE_KEY, lhm_page_type: PAGE_TYPE }, p || {}));
    };
  } else {
    window.lhmTrack = send;
  }
  window.__lhmTrack = 1;

  function trim(s, n) {
    s = (s || "").replace(/\s+/g, " ").trim();
    return s.length > n ? s.slice(0, n) : s;
  }

  function linkKind(href) {
    if (!href) return "none";
    if (href.indexOf("tel:") === 0) return "tel";
    if (href.indexOf("mailto:") === 0) return "mailto";
    if (href.charAt(0) === "#") return "anchor";
    var a = document.createElement("a");
    a.href = href;
    if (a.hostname && a.hostname !== location.hostname) return "external";
    var p = a.pathname || "";
    if (p.indexOf("/products/") === 0) return "product";
    if (p.indexOf("/collections/") === 0) return "collection";
    if (p.indexOf("/blogs/") === 0) return "article";
    if (p.indexOf("/pages/") === 0) return "page";
    if (p.indexOf("/cart") === 0) return "cart";
    return "internal";
  }

  function linkPath(href) {
    if (!href) return "";
    if (href.indexOf("tel:") === 0 || href.indexOf("mailto:") === 0) return href;
    var a = document.createElement("a");
    a.href = href;
    return a.hostname === location.hostname ? (a.pathname + a.search) : a.href;
  }

  /* Where on the page the thing sat, so a blog body link can be told apart from
     the shop-by-decision list at the bottom. */
  function zoneOf(el) {
    var z = el.closest("[data-lhm-zone]");
    if (z) return z.getAttribute("data-lhm-zone");
    if (el.closest(".calc-result, #fr-detail")) return "result";
    if (el.closest(".bom-wrap, .kit-compare, table")) return "table";
    if (el.closest(".cta-box, .trust-call")) return "cta";
    if (el.closest(".calc-form, form")) return "form";
    if (el.closest("nav, header")) return "nav";
    if (el.closest("footer")) return "footer";
    return "body";
  }

  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a) return;
    var href = a.getAttribute("href") || "";
    var kind = linkKind(href);
    /* tel: is deliberately skipped. The theme already fires phone_click on every
       page, and a second event for the same tap would read as two numbers for
       one action. phone_click owns calls. */
    if (kind === "tel") return;
    send("lhm_link_click", {
      lhm_link_url: trim(linkPath(href), 100),
      lhm_link_text: trim(a.textContent || a.getAttribute("aria-label"), 100),
      lhm_link_kind: kind,
      lhm_link_zone: zoneOf(a)
    });
  }, true);

  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target.closest("button, [role=button]") : null;
    if (!t) return;
    send("lhm_button_click", {
      lhm_field: trim(t.id || t.name || t.className, 60),
      lhm_link_text: trim(t.textContent, 60),
      lhm_link_zone: zoneOf(t)
    });
  }, true);

  var READABLE_INPUT = { number: 1, range: 1, checkbox: 1, radio: 1, date: 1 };

  function readable(el) {
    if (el.tagName === "SELECT") return true;
    if (el.tagName !== "INPUT") return false;
    if (el.hasAttribute("data-lhm-value")) return true;
    return !!READABLE_INPUT[(el.type || "").toLowerCase()];
  }

  function valueOf(el) {
    if (el.type === "checkbox" || el.type === "radio") return el.checked ? "on" : "off";
    if (el.tagName === "SELECT") {
      var o = el.options && el.options[el.selectedIndex];
      return trim(o ? (o.value || o.text) : el.value, 60);
    }
    return trim(el.value, 40);
  }

  document.addEventListener("change", function (e) {
    var el = e.target;
    if (!el || !el.tagName) return;
    if (el.tagName !== "SELECT" && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA") return;
    var name = trim(el.id || el.name || el.className, 60);
    if (!readable(el)) {
      send("lhm_field_change", { lhm_field: name, lhm_field_value: "(not captured)" });
      return;
    }
    send("lhm_field_change", { lhm_field: name, lhm_field_value: valueOf(el) });
  }, true);

  document.addEventListener("click", function (e) {
    var w = e.target && e.target.closest ? e.target.closest("[data-lhm-widget]") : null;
    if (!w) return;
    send("lhm_widget_action", {
      lhm_widget: trim(w.getAttribute("data-lhm-widget"), 60),
      lhm_choice: trim(w.getAttribute("data-lhm-choice") || w.textContent, 60)
    });
  }, true);

  var marks = [25, 50, 75, 100], hit = {};
  function onScroll() {
    var h = document.documentElement;
    var max = (h.scrollHeight - h.clientHeight);
    if (max <= 0) return;
    var pct = Math.round(((window.pageYOffset || h.scrollTop) / max) * 100);
    for (var i = 0; i < marks.length; i++) {
      if (pct >= marks[i] && !hit[marks[i]]) {
        hit[marks[i]] = 1;
        send("lhm_scroll", { lhm_scroll_pct: marks[i] });
      }
    }
  }
  var st;
  window.addEventListener("scroll", function () {
    clearTimeout(st);
    st = setTimeout(onScroll, 200);
  }, { passive: true });

  /* Engaged time counts only while the tab is visible, reported once on exit. */
  var started = Date.now(), engaged = 0, visible = !document.hidden, done = false;
  function stopClock() { if (visible) { engaged += Date.now() - started; visible = false; } }
  function startClock() { if (!visible) { started = Date.now(); visible = true; } }
  document.addEventListener("visibilitychange", function () {
    document.hidden ? stopClock() : startClock();
  });
  function report() {
    if (done) return;
    done = true;
    stopClock();
    var secs = Math.round(engaged / 1000);
    if (secs > 0) send("lhm_page_engagement", { lhm_engaged_seconds: secs });
  }
  window.addEventListener("pagehide", report);
  document.addEventListener("visibilitychange", function () { if (document.hidden) report(); });

  if (DEBUG) try { console.log("[lhm] telemetry ready", PAGE_KEY, PAGE_TYPE); } catch (e) {}
})();
